import React from 'react'
import { Route, Switch, BrowserRouter } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import ManagerHome from './pages/ManagerHome'
// import RemoteRouter from './components/manager/remote/RemoteRouter'
// import StreamRouter from './components/manager/stream/StreamRouter'
import Auth0ProviderWithHistory from './auth/Auth0ProviderWithHistory'

const Routes = () => {
  return (

    <BrowserRouter>
      <Auth0ProviderWithHistory>
        <Switch>
          {/* <Route path='/stream' component={StreamRouter} />
          <Route path='/remote' component={RemoteRouter} /> */}
          <Route exact path='/manager' component={ManagerHome} />
          <Route exact path='/' component={LandingPage} />
        </Switch>
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  )
}

export default Routes
